<h3 class="text-center">Gifts List</h3>
<div class="table-responsive" *ngIf="gifts.length>0">
<table datatable [dtOptions]="dtOptions" class="table table-striped display compact" >
    <thead>
    <tr>
        <th>Date Created</th>
        <th>name</th>
        <th>Description</th>
        <th>Category</th>
        <th>Edit</th>
    </tr>
    </thead>
    <tbody>

        <tr *ngFor="let educSystem of gifts;">
        <td>{{educSystem['datecreated']}} </td>
        <td>{{educSystem['name']}}</td>
        <td>{{educSystem['description']}}</td>
        <td>{{educSystem['gift_category_name']}}</td>

        <td>
          <a [routerLink]="['/admin/gifts/edit',educSystem.id]">
            <i class="fa fa-edit"></i> Edit
           </a>
        </td>
    </tr>

    </tbody>

</table>

</div>
<div *ngIf="!loading && gifts.length==0" class="alert alert-info text-center">No Gifts  Found</div>
<hr/>
<div class="text-center" >
  <a [routerLink]="['/admin/gifts/edit/',0]" class="me-2"><i class="fa fa-plus"></i> Add New Gift</a>
  <a [routerLink]="['/home/admin/show']"><i class="fa fa-plus"></i> Close</a>

</div>
